import { render, staticRenderFns } from "./TableFooter.vue?vue&type=template&id=2e14b465"
import script from "./TableFooter.vue?vue&type=script&lang=ts"
export * from "./TableFooter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports